import { Component, OnInit, Input } from '@angular/core';
import {
  Service,
  SundryCharge,
  WaybillPayload,
  sundryChargeTypes,
  SundryChargeType,
  ServiceType,
  serviceTypes
} from "src/interfaces/waybill";

@Component({
  selector: 'core-waybill-review',
  templateUrl: './waybill-review.component.html',
  styleUrls: ['./waybill-review.component.scss']
})
export class WaybillReviewComponent implements OnInit {
  @Input() waybillPayload: WaybillPayload;
  sundryChargeTypes = sundryChargeTypes;
  disableAnimation: boolean = true;
  serviceTypes = serviceTypes;
  constructor() { }

  ngOnInit(): void {
  }

  get serviceType(): string {
    const serviceType: ServiceType | undefined = this.serviceTypes
      .find(type => type.code === this.waybillPayload.serviceType);
    return serviceType ? serviceType.name : "-";
  }

  get totalQuantity(): number | undefined {
    return this.waybillPayload.totQTY;
  }

  get totalMass(): number | undefined {
    return this.waybillPayload.totMass;
  }

  get isInsured(): string {
    return this.waybillPayload.insurance ? 'Yes' : 'No';
  }

  get completeWaybillAfterSave(): string {
    return this.waybillPayload.completeWaybillAfterSave ? 'Yes' : 'No';
  }

  get isSecureDelivery(): string {
    return this.waybillPayload.isSecureDelivery ? 'Yes' : 'No';
  }

  get generateSecurePIN(): string {
    return this.waybillPayload.generateSecurePin ? 'Yes' : 'No';
  }

  get bookedDate(): string {
    if (!this.waybillPayload.bookedDate) return "";
    return new Date(this.waybillPayload.bookedDate).toDateString();

  }

  getSundryChargeName(sundryCharge: SundryCharge) {
    const sundryChargeType: SundryChargeType | undefined = this.sundryChargeTypes
      .find(sundryChargeType => sundryChargeType.code === sundryCharge.Code)
    return sundryChargeType ? sundryChargeType.name : "";
  }
}
